import { isValidRouteParam } from "components/SelectHqOfficeCombobox/helper";
import { Box } from "@adfenix/alexandria";
import { Modal } from "components/Modal";
import SelectHqOfficeCombobox from "components/SelectHqOfficeCombobox";
import { matchPath } from "react-router-dom";
import { selectHqOfficeModalState } from "atoms/selectedHqHoc";
import styled from "styled-components";
import { PathMatch, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { userSelectedHq } from "atoms/auth";
import { ConfigurationService } from "@adfenix/types";

const StyledBox = styled(Box)`
  min-height: 360px;
`;

interface PageModalProps {
  hqs?: ConfigurationService.HqAndDomainModel[];
}

export const CustomerSelectHqOfficeModal = ({ hqs }: PageModalProps) => {
  const navigate = useNavigate();
  const [modalState, setModalState] = useRecoilState(selectHqOfficeModalState);
  const selectedHq = useRecoilValue(userSelectedHq);
  const matchHqAndOfficePath: PathMatch<"hqId" | "officeId"> | null = matchPath(
    { path: "/customer/hq/:hqId/office/:officeId", end: false },
    location.pathname
  );

  const matchHqPath = matchPath(
    { path: "/customer/hq/:hqId", end: false },
    location.pathname
  );

  const handleClose = () => {
    if (
      matchHqPath?.params.hqId === ":hqId" ||
      matchHqAndOfficePath?.params.officeId === ":officeId"
    ) {
      navigate(-1);
    }

    setModalState(false);
  };

  const shouldSelectOffice =
    matchHqAndOfficePath !== null &&
    !!matchHqAndOfficePath.params.officeId &&
    isValidRouteParam(matchHqAndOfficePath.params.officeId);

  const preSelectedHq =
    matchHqAndOfficePath?.params.hqId === ":hqId"
      ? selectedHq?.id
      : matchHqAndOfficePath?.params.hqId;

  return (
    <Modal onClose={() => handleClose()} show={modalState}>
      <Modal.Card>
        <Modal.Card.Head onClose={() => handleClose()}>
          <Modal.Card.Title>
            {shouldSelectOffice ? "Select HQ and Office" : "Select HQ"}
          </Modal.Card.Title>
        </Modal.Card.Head>

        <Modal.Card.Body>
          <StyledBox pX="s">
            <SelectHqOfficeCombobox
              hqs={hqs}
              shouldSelectOffice={shouldSelectOffice}
              preSelectedHqId={preSelectedHq}
              onlyShowAuthorizedOffices
            />
          </StyledBox>
        </Modal.Card.Body>
      </Modal.Card>
    </Modal>
  );
};
